export default {
    reading_room: {
        readingroom: 'Reading room',
    },
    'Выберите нужные форматы для скачивания:': 'Select the required formats for download:',
    download_limit_exceeded: 'Download limit exceeded, for model downloads please confirm that you are not a robot',
    'Что мы предлагаем': 'What We Offer',
    'Проектировщику': 'Designers',
    'BIM-менеджеру': 'BIM-managers',
    'Запросить обоснование цены на материалы': 'Request material price justification',
    'Всегда под рукой актуальные и достоверные данные для обоснования цены и конъюнктурного анализа': 'You always have relevant and reliable data for price justification and market analysis.',
    'Запросить актуальную стоимость строительства': 'Request actual construction cost',
    'Быстрый и точный перерасчёт сметы в реальные деньги на сегодня': 'Fast and accurate budget re-calculation and conversion in today’s currencies.',
    'Получить ТКП': 'Obtain a technical commercial proposal',
    'Никаких звонков и общения с продавцами. Защитим от спам-рассылок и звонков, сохранив конфиденциальность данных': 'No calls or negotiations with sellers. We will prevent spam emails or calls by protecting your data privacy.',
    'Запросить прайс-листы': 'Request price-lists',
    'Не тратьте время на поиск, поручите это нам. Больше не придется отвлекаться': 'Don’t waste your time on searches, let us do it for you while you concentrate on work.',
    'Рассчитать проект': 'Project budgeting',
    'Хватит работать с бесконечными таблицами, рассчитывая стоимость каждого пункта вручную. Больше никакой рутинной работы': 'Stop working with endless tables calculating the cost of each item manually. No more routine workflow from now on.',
    'Подобрать аналоги': 'Choose analogues',
    'Равные по качеству или даже лучше. Постараемся найти более выгодные решения': 'Of the same or even better quality. We will find the best solutions.',
    'Убрать дубли в номенклатуре': 'Eliminate duplicates and ambiguity',
    'Упростим работу с каталогами и сэкономим ваше время': 'We will simplify your work with catalogues and save your time.',
    'Другое': 'Other',
    'Вашей задачи нет в списке?': 'Did not find your issue on the list?',
    'Оставьте заявку': 'Send us a request',
    '— поможем': 'and we will help you.',
    'Запросить шаблоны семейств с параметрами ГОСТ и ТУ': 'Request family templates with GOST and specification parameters.',
    'Вам не придется никому звонить. Через нас вы получите качественные данные на всех этапах от проекта, до закупки и эксплуатации': 'You do not need to make any calls. With us you will obtain quality data on every project stage including procurement and maintenance.',
    'Сопоставить номенклатуру и BIM-модели компонентов': 'BIM-models match product ranges',
    'Теперь все данные будут связаны, что позволит создать общую среду': 'All data will be connected to create common environment.',
    'Сформировать EIR и разработать BEP': 'Create EIR and BEP',
    'Обеспечим единые требования к результатам моделирования для исполнителей. Вы получите ожидаемый качественный результат': 'By creating Employer’s Information Requirements (EIR) and BIM Execution Plan (BEP) we provide uniform requirements for design simulations. The result will either meet or exceed your expectations.',
    'Провести аудит или экспертизу BIM-модели': 'Conduct audit or carry out expert assessment of BIM-models',
    'Равные по качеству или даже лучше. Постараемся найти более выгодные решения': 'Of the same or even better quality. We will find the best solutions.',
    'Другое': 'Other',
    'Заполните форму': 'Fill in the form',
    'НОМЕР ТЕЛЕФОНА': '',
    'Отправляя свои данные, вы соглашаетесь с': 'By submitting the information you accept our',
    'политикой конфиденциальности': 'Privacy Policy',
    'введите номер телефона': 'Enter Your Phone Number',
    'Далее': 'Next',
    'Телефон': 'Phone',
    'готово к отправке': 'Ready for submit',
    'Отправить заявку': 'Submit',
    'Электронная почта': 'E-mail',
    'Имя': 'Name',
    'Размещение': 'Placement',
    'Страница с информацией о компании на портале BIMLIB с видео и текстовой информацией': 'Web-page with your corporate information which supports text- and video ﬁles (information is moderated).',
    'Размещение неограниченного числа карточек моделей в BIM-библиотеке': 'Import of any number of BIM object cards to BIM Library.',
    'Создание персональных разделов – каталог производителя': 'Personal sections - supplier’s catalog.',
    'Доступность всех моделей производителя в плагине BIMLIB для САПР': 'Access to all objects of BIMLIB plugin for CAD.',
    'Широкие возможности встраивания информации из сформированной библиотеки на сторонних сайтах': 'Wide range of features to embed information from the library on third-party web-sites.',
    'Статистика скачиваний и просмотров по размещенной информации в личном кабинете': 'Detailed statistics of views and downloads on your dashboard.',
    'Бесплатно': 'Free',
    'Базовый': 'Basic',
    'Размещение видеороликов на странице модели': 'Upload video for model',
    'Уведомления о загрузках моделей на электронную почту с указанием контактных данных': 'Email notiﬁcations of new loads with designer’s contact details',
    'Прямая коммуникации с пользователями портала, взаимодействующими с моделями и цифровыми каталогами': 'Direct communication with users who load BIM objects',
    'Блог компании в Читальном зале': 'Corporate blog in our Reading Room (information is moderated)',
    'Индивидуальный': 'Individual',
    'Написание уникальных статейных материалов на тему применения BIM-технологий': 'Original content on application of BIM-technologies (up to 6 per year).',
    'Включение в электронную рассылку по аудитории портала': 'Appear in newsletters to our subscribers (up to 12 per year).',
    'Создание и размещение видеороликов о BIM-моделях и работе с ними на официальном YouTube канале BIMLIB': 'Create and post videos on BIM objects and workﬂow on our ofﬁcial YouTube channel (up to 6 per year).',
    'Возможность размещения калькулятора продукции в плагине BIMLIB для САПР': 'Place a calculator in BIMLIB plugin for CAD',
    'Приоритетная техническая поддержка': 'Get priority technical support.',
    'Результат': 'Result',
    'Персональный аккаунт менеджер,  задействованный в вашем успешном продвижении на портале': 'Dedicated account manager',
    'Возможность привлечения экспертов BIMLIB в качестве спикеров на мероприятия': 'Involve BIMLIB experts to your corporate events: seminars, webinars, exhibitions, conferences (once per year).',
    '+ Возможности тарифа «Размещение»': '+ features of "Placement" plan',
    '+ Возможности тарифа «Базовый»': '+ features of "Basic" plan',
    '+ Возможности тарифа «Индивидуальный»': '+ features of "Individual" plan',
    'Выбрать': 'Select',
    'руб. в год': 'EUR per year',
    'Введите номер телефона': 'Enter tel. number',
    'Все данные шифруются и передаются напрямую нашим специалистам': 'All data is encrypted and translates to our specialists directly',
    'Доступен всем после регистрации': 'Available after registration',
    'Номер телефона должен содержать только цифры и быть в пределах от 6 до 15 символов': 'Phone number must contain min 6 - max 15 character length, only numbers',
    'Тарифы': 'Plans',
    'Все': 'All',
    'Продукты': 'Products',
    'Производители': 'Manufacturers',
    'ООО «ИТМ»': 'BIM LLC',
    'Статьи': 'Articles',
    'Не нашли то что искали?': 'Did not find what you are looking for?',
    'Введите запрос': 'Search',
    'Скачать': 'Download',
    'Скачать плагин': 'Download plugin',
    '60 000': '900',
    '120 000': '1 800',
    '180 000': '2 700',
    '45 000': '675',
    '90 000': '1350',
    'РУБ. / ГОД': 'EUR / year',
    'руб. / полгода': 'eur / 6 months',
    'О компании': 'About us',
    'Вакансии': 'Careers',
    'buildingSMART Int.': 'buildingSMART Int.',
    'Открытая статистика': 'Open statistics',
    'Пользовательское соглашение': 'User agreement',
    'Политика конфиденциальности': 'Privacy Policy',
    'Модели': 'Models',
    'Статьи': 'Articles',
    'Поиск по библиотеке': 'Search',
    'Новые публикации': 'New epubs',
    'Показать ещё': 'Show more',
    'С нами работают производители': 'Our clients',
    'companyCount': '{count} companies more',
    'Мастер спецификаций': 'CAD plugin',
    'Наши кейсы': 'Customers\' success',
    'Наш бесплатный сервис для проектировщиков': 'Our free service for designers',
    'Наш канал в Telegram': 'Our Telegram',
    'Получайте свежие новости из мира BIM первыми. Подпишитесь на канал BIMLIB в Telegram': 'Be the first with getting the latest news from BIM world. Subscribe to the BIMLIB channel',
    'Мы создали более {count} моделей, вот некоторые из них:': 'We have created over {count} models, here are a few of them:',
    'Календарь событий': 'Calendar of events'
}